export class HUD {
  private container: HTMLElement;
  private scoreEl: HTMLElement;
  private bannerEl: HTMLElement;
  private livesEl: HTMLElement;
  private audioBtn: HTMLElement;

  private currentDisplayScore: number = 0;
  private targetScore: number = 0;
  private isMuted: boolean = false;
  private onMuteToggle?: (muted: boolean) => void;

  constructor(container: HTMLElement, onMuteToggle?: (muted: boolean) => void) {
    this.container = container;
    this.onMuteToggle = onMuteToggle;

    this.container.innerHTML = `
      <div id="hud-root" class="hud-root">
        <div class="hud-top-left">
          <div class="hud-lives-container" id="hud-lives">
            <span class="hud-label">LIVES</span>
            <div class="hud-lives-dots" id="lives-dots">
              <span class="life-dot active"></span>
              <span class="life-dot active"></span>
              <span class="life-dot active"></span>
            </div>
          </div>
        </div>

        <div class="hud-top-right">
          <div class="hud-score-card">
            <span class="hud-label">SCORE</span>
            <div class="hud-score-number" id="hud-score-val">0</div>
          </div>
          <button id="hud-audio-btn" class="hud-icon-btn" title="Toggle Sound" aria-label="Toggle Sound">
            🔊
          </button>
        </div>

        <div id="hud-high-score-banner" class="hud-banner hidden">
          <div class="hud-banner-title">⚡ NEW HIGH SCORE! ⚡</div>
          <div class="hud-banner-value" id="hud-banner-score">0</div>
        </div>
      </div>
    `;

    this.scoreEl = document.getElementById('hud-score-val')!;
    this.bannerEl = document.getElementById('hud-high-score-banner')!;
    this.livesEl = document.getElementById('lives-dots')!;
    this.audioBtn = document.getElementById('hud-audio-btn')!;

    this.audioBtn.addEventListener('click', () => {
      this.isMuted = !this.isMuted;
      this.audioBtn.textContent = this.isMuted ? '🔇' : '🔊';
      if (this.onMuteToggle) this.onMuteToggle(this.isMuted);
    });
  }

  show(): void {
    this.container.style.display = 'block';
    if (this.bannerEl) {
      this.bannerEl.classList.add('hidden');
    }
  }

  hide(): void {
    this.container.style.display = 'none';
  }

  setScore(score: number): void {
    this.targetScore = score;
    if (score === 0 || score <= this.currentDisplayScore) {
      this.currentDisplayScore = score;
      if (this.scoreEl) {
        this.scoreEl.textContent = Math.floor(this.currentDisplayScore).toLocaleString();
      }
    }
  }

  update(): void {
    if (this.currentDisplayScore < this.targetScore) {
      this.currentDisplayScore += Math.max(1, (this.targetScore - this.currentDisplayScore) * 0.1);
      this.scoreEl.textContent = Math.floor(this.currentDisplayScore).toLocaleString();
    } else if (this.currentDisplayScore > this.targetScore) {
      this.currentDisplayScore = this.targetScore;
      this.scoreEl.textContent = Math.floor(this.currentDisplayScore).toLocaleString();
    }
  }

  setLives(lives: number): void {
    const dots = this.livesEl.querySelectorAll('.life-dot');
    dots.forEach((dot, idx) => {
      if (idx < lives) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  showHighScoreBanner(score: number): void {
    const bannerScore = document.getElementById('hud-banner-score');
    if (bannerScore) bannerScore.textContent = score.toLocaleString();
    this.bannerEl.classList.remove('hidden');

    setTimeout(() => {
      this.bannerEl.classList.add('hidden');
    }, 3500);
  }
}
